import { SelectedData } from 'owa-addins-core';
import { ComposeViewState } from 'owa-mail-compose-store';
import updateSubject from 'owa-mail-compose-store/lib/actions/updateSubject';
import updateSubjectSelectionRange from 'owa-mail-compose-store/lib/actions/updateSubjectSelectionRange';
import { ComposeControl } from 'owa-mail-compose-store/lib/utils/getAutoFocusControl';

export const getSubject = (viewState: ComposeViewState) => (): string => {
    return viewState.subject;
};

export const setSubject = (viewState: ComposeViewState) => (subject: string): void => {
    updateSubject(viewState, subject);
};

export const setSubjectSelectedData = (viewState: ComposeViewState) => (content: string): void => {
    if (!isSubjectLineLastFocusedControl(viewState)) {
        return;
    }

    let value = viewState.subject;
    const { selectionStart, selectionEnd } = viewState.subjectViewState;
    value = value.slice(0, selectionStart) + content + value.slice(selectionEnd);
    updateSubject(viewState, value);
    const cursorPosition = selectionStart + content.length;
    updateSubjectSelectionRange(viewState, cursorPosition, cursorPosition);
};

export const getSubjectSelectedData = (viewState: ComposeViewState) => (): SelectedData => {
    if (!isSubjectLineLastFocusedControl(viewState)) {
        return null;
    }

    const { selectionStart, selectionEnd } = viewState.subjectViewState;

    let value = viewState.subject;
    value = value.slice(selectionStart, selectionEnd);

    return {
        data: value,
        sourceProperty: 'subject',
        startPosition: selectionStart,
        endPosition: selectionEnd,
    };
};

function isSubjectLineLastFocusedControl(viewState: ComposeViewState): boolean {
    return viewState.lastFocusedControl === ComposeControl.SubjectLine;
}
